import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('periodicities', storeModule.createStoreModule('periodicities'))
